/**
 * Mini util multimedia: vibrazione + suono "ding" sintetico al raggiungimento del punto.
 * Nessuna libreria esterna — Web Audio API + Vibration API native.
 */

let _audioCtx = null;
function _getAudio() {
  if (_audioCtx) return _audioCtx;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    _audioCtx = new Ctx();
    return _audioCtx;
  } catch { return null; }
}

/** Vibrazione corta (~150ms). Silenziosa se l'utente è in mute o il browser non supporta. */
export function vibrate(ms = 150) {
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") {
      navigator.vibrate(ms);
    }
  } catch { /* noop */ }
}

/** Suono "ding" sintetico (due note ascendenti). Silenzioso se Web Audio non disponibile. */
export function playDing() {
  const ctx = _getAudio();
  if (!ctx) return;
  try {
    // Riprende il contesto se sospeso da policy autoplay del browser
    if (ctx.state === "suspended") ctx.resume();
    const now = ctx.currentTime;
    const tones = [
      { freq: 880, start: 0,    duration: 0.16 }, // A5
      { freq: 1320, start: 0.10, duration: 0.22 }, // E6 (5a sopra)
    ];
    tones.forEach((t) => {
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = "sine";
      osc.frequency.setValueAtTime(t.freq, now + t.start);
      gain.gain.setValueAtTime(0, now + t.start);
      gain.gain.linearRampToValueAtTime(0.18, now + t.start + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + t.start + t.duration);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now + t.start);
      osc.stop(now + t.start + t.duration + 0.02);
    });
  } catch { /* noop */ }
}

/** Combo: vibra + suona. Idempotente, sicuro. */
export function notifyArrival() {
  vibrate(180);
  playDing();
}
